const FORM_NAME = 'discount_form';

export {
    FORM_NAME,
};
